
export default {
  // Influencer Page
  influencerTitle: "Connect with Top Influencers",
  influencerSubtitle: "Boost Your Brand with Influencer Marketing",
  influencerDescription: "Partner with leading influencers to amplify your message and reach new audiences",
  browseCameos: "Browse Cameos",
  influencerStats: "Influencer Stats",
  influencerReach: "Influencer Reach",
  averageEngagement: "Average Engagement",
  successfulCampaigns: "Successful Campaigns",
  bookInfluencer: "Book Influencer",
  viewInfluencers: "View All Influencers",
  
  // Cameo Page
  cameosTitle: "Personalized Videos from Your Favorite Influencers",
  cameosDescription: "Book personalized videos for your brand or personal use",
  personalizedVideos: "Personalized Videos",
  forBrands: "For Brands",
  categories: "Categories",
  featured: "Featured",
  trending: "Trending",
  all: "All",
  search: "Search",
  searchPlaceholder: "Search for influencers",
  priceRange: "Price Range",
  responseTime: "Response Time",
  bookNow: "Book Now",
  viewProfile: "View Profile",
  
  // Influencer Booking Page
  bookInfluencerTitle: "Book Your Influencer Campaign",
  bookInfluencerDesc: "Create impactful campaigns with our top influencers",
  searchInfluencers: "Search Influencers",
  customBooking: "Custom Booking",
  customBookingDesc: "Create a tailored influencer campaign",
  view: "View",
  book: "Book",
  
  // Influencer Detail Page
  backToInfluencers: "Back to Influencers",
  perCampaign: "Per Campaign",
  followers: "Followers",
  expertise: "Expertise",
  aboutInfluencer: "About Influencer",
  contactDetails: "Contact Details",
  socialProfiles: "Social Profiles",
  pricingInformation: "Pricing Information",
  standardCampaign: "Standard Campaign",
  extendedCampaign: "Extended Campaign",
  personalizedVideo: "Personalized Video",
  whatYouGet: "What You Get",
  contentCreation: "Content Creation",
  socialMediaPosts: "Social Media Posts",
  engagementWithAudience: "Engagement With Audience",
  performanceReport: "Performance Report",
  contactInformation: "Contact Information",
  getInTouch: "Get In Touch",
  bookingInstructions: "Booking Instructions",
  scheduleCall: "Schedule Call",
  similarInfluencers: "Similar Influencers",
  noSimilarInfluencers: "No Similar Influencers Found",
  comingSoon: "Coming Soon",
  
  // Influencer Sign Up
  becomeInfluencer: "Become an Influencer",
  joinAsInfluencer: "Join as an Influencer",
  influencerSignUpDesc: "Complete your profile to join our platform and connect with brands",
  basicInfo: "Basic Information",
  yourName: "Your Name",
  categoryLabel: "Category",
  selectCategory: "Select category",
  aboutYou: "About You",
  followersCount: "Followers Count",
  campaignPrice: "Campaign Price (SAR)",
  profileImageUrl: "Profile Image URL",
  areasOfExpertise: "Areas of Expertise",
  socialMediaLinks: "Social Media Links",
  contactInfo: "Contact Information",
  submitApplication: "Submit Application",
  applicationSubmitted: "Application Submitted!",
  applicationUnderReview: "Your application is under review. We'll notify you soon.",
  alreadyHaveProfile: "You Already Have a Profile",
  status: "Status",
  approved: "Approved",
  pending: "Pending Review",
  rejected: "Rejected",
  rejectionReason: "Rejection Reason",
  
  // Admin Approval
  influencerApproval: "Influencer Approval",
  pendingApprovals: "Pending Approvals",
  approvedInfluencers: "Approved Influencers",
  rejectedInfluencers: "Rejected Influencers",
  approve: "Approve",
  reject: "Reject",
  confirmRejection: "Confirm Rejection",
  rejectInfluencer: "Reject Influencer",
  rejectionReasonOptional: "Rejection Reason (optional)",
} as const;
